"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONTableWidthUnitConverter = exports.JSONTableHeightUnitConverter = void 0;
var table_units_1 = require("../../../tables/secondary-structures/table-units");
var json_table_structures_enums_1 = require("../../enums/table/json-table-structures-enums");
var JSONTableHeightUnitConverter = (function () {
    function JSONTableHeightUnitConverter() {
    }
    JSONTableHeightUnitConverter.convertFromJSON = function (obj) {
        var result = new table_units_1.TableHeightUnit();
        result.type = obj[json_table_structures_enums_1.JSONTableHeightUnitProperty.Type];
        result.value = obj[json_table_structures_enums_1.JSONTableHeightUnitProperty.Value];
        return result;
    };
    JSONTableHeightUnitConverter.convertToJSON = function (source) {
        var result = {};
        result[json_table_structures_enums_1.JSONTableHeightUnitProperty.Type] = source.type;
        result[json_table_structures_enums_1.JSONTableHeightUnitProperty.Value] = source.value;
        return result;
    };
    return JSONTableHeightUnitConverter;
}());
exports.JSONTableHeightUnitConverter = JSONTableHeightUnitConverter;
var JSONTableWidthUnitConverter = (function () {
    function JSONTableWidthUnitConverter() {
    }
    JSONTableWidthUnitConverter.convertFromJSON = function (obj) {
        var result = new table_units_1.TableWidthUnit();
        result.type = obj[json_table_structures_enums_1.JSONTableWidthUnitProperty.Type];
        result.value = obj[json_table_structures_enums_1.JSONTableWidthUnitProperty.Value];
        return result;
    };
    JSONTableWidthUnitConverter.convertToJSON = function (source) {
        var result = {};
        result[json_table_structures_enums_1.JSONTableWidthUnitProperty.Type] = source.type;
        result[json_table_structures_enums_1.JSONTableWidthUnitProperty.Value] = source.value;
        return result;
    };
    return JSONTableWidthUnitConverter;
}());
exports.JSONTableWidthUnitConverter = JSONTableWidthUnitConverter;
